import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { AxiosError } from 'axios';
import browserHistory from '../../history';
import ApiService from '../../services/ApiService';
import Form from '../form/Form';
import toastr from '../toastr';

interface Props {
  onCancel?: () => void;
  onSubmit?: (data: object) => any;
  onError?: (err: Error) => any;
}

const PairTerminalForm = ({ onSubmit = () => null, onError = () => null, onCancel = () => null }: Props) => {
  const user = useSelector((state: any) => state.app.user);

  const formRef = useRef<any>(null);

  const layout = [
    {
      type: 'section',
      label: 'Terminal Details',
      col: 6,
      fields: [
        {
          label: 'Terminal Name',
          name: 'name',
          required: true,
          col: 6,
          helpText: 'Make up a name to easily identify the terminal',
        },
        {
          label: 'Terminal Serial Number',
          name: 'TerminalSerialNumber',
          required: true,
          col: 6,
          helpText: 'Locate S/N on the back of the terminal',
        },
        { label: 'Terminal Description', name: 'description', col: 12, control: 'textarea' },
      ],
    },
    {
      type: 'section',
      label: 'Location',
      col: 6,
      fields: [
        {
          name: 'branchId',
          label: 'Branch',
          validation: {
            type: 'db',
            modelName: 'branch',
            sortBy: 'name',
          },
        },

        { label: 'Business Name', name: 'BusinessName', required: true, col: 6 },
        {
          label: 'Contact Name',
          name: 'ContactName',
          required: true,
          col: 6,
          data: `${user.firstName} ${user.lastName}`,
        },
        { label: 'Email', name: 'Email', type: 'email', required: true, col: 6, data: user.email },
        { label: 'Phone', name: 'Phone', type: 'phone', required: true, col: 6 },
        { label: 'Address', name: 'Address', required: true, col: 6 },
        { label: 'City', name: 'City', required: true, col: 6 },
        { label: 'State', name: 'State', required: true, col: 4 },
        { label: 'ZipCode', name: 'ZipCode', required: true, col: 4 },
        {
          label: 'Country',
          name: 'Country',
          control: 'select',
          options: [
            { label: 'USA', value: 'USA' },
            { label: 'Canada', value: 'Canada' },
          ],
          noEmptyOption: false,
          data: 'USA',
          col: 4,
        },
      ],
    },
  ];

  const handleSubmit = (data: any) => {
    ApiService.post('/payment/terminal', data)
      .then((response: any) => {
        toastr.success('Terminal Paired');
        browserHistory.push('/UPY2');
        onSubmit(response.data);
      })
      .catch((err: AxiosError) => {
        toastr.error(err.message);
        onError(err);
      });
  };

  const handleChange = ({ form, name }: { form: any; name: string }) => {
    if (name !== 'branchId') {
      return;
    }

    const branchId = form.branchId.data;

    if (!branchId) {
      return;
    }

    ApiService.get(`/db/UST2/${branchId}`).then((response: any) => {
      const { data } = response;

      // update some fields automatically when the branch is changed
      formRef.current!.updateForm({
        BusinessName: data.name,
        Phone: data.phone,
        ZipCode: data.zipcode,
        Address: data.street,
        State: data.state,
        City: data.city,
      });
    });
  };

  return (
    <Form
      ref={formRef}
      layout={layout}
      submit={handleSubmit}
      onCancel={onCancel}
      onChange={handleChange}
      exportFormat="object"
      showHelp
      submitAll
    />
  );
};

export default PairTerminalForm;
